var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.156 1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.981,94.56c6.086,0,11.02-1.754,11.02-3.917s-4.934-3.917-11.02-3.917-11.02,1.754-11.02,3.917S8.895,94.56,14.981,94.56Z",
    transform: "translate(0.66 14.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.573,108.44c6.087,0,11.02-1.754,11.02-3.917s-4.934-3.917-11.02-3.917-11.019,1.754-11.019,3.917S161.488,108.44,167.573,108.44Z",
    transform: "translate(26.092 16.768)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.158,3.926a63.993,63.993,0,0,1-45.085.592C47.259-3,20.076-4.921,10,29.522c-17.192,58.845,17.98,79.849,17.98,79.849s24.555,5.505,38.151,15.452c19.313,14.13,42.965,18.852,65.245,12.227,14.247-4.237,26.459-11.188,29.951-22.563,9.764-31.812,3.565-50.932,21.236-59.32S190.4,15.706,177.837,15,135.662,21.5,126.5,7.167C123.238,2.077,118.243,1.96,113.158,3.926Z",
    transform: "translate(0.878 0)",
    fill: "#e7f1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.921,109s2.939-10-.554-17.357a15.791,15.791,0,0,1-1.278-9.908,26.62,26.62,0,0,1,1.4-4.651",
    transform: "translate(27.299 12.847)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.386,73.416c0,1.224,2.219,4.779,2.219,4.779s2.218-3.552,2.218-4.779a2.22,2.22,0,1,0-4.439,0Z",
    transform: "translate(27.231 11.866)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.293,79.407c.666,1.028,4.461,2.806,4.461,2.806s-.069-4.189-.734-5.217a2.219,2.219,0,1,0-3.725,2.411Z",
    transform: "translate(26.657 12.664)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.551,89.457c1.1.551,5.268.171,5.268.171s-2.175-3.582-3.269-4.132a2.218,2.218,0,0,0-2,3.961Z",
    transform: "translate(26.555 14.21)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.305,96.929c.98.734,5.163,1.057,5.163,1.057s-1.538-3.9-2.522-4.624a2.219,2.219,0,1,0-2.64,3.567Z",
    transform: "translate(26.901 15.488)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.769,82.07c-.879.854-4.976,1.738-4.976,1.738s1-4.066,1.883-4.921a2.219,2.219,0,1,1,3.093,3.183Z",
    transform: "translate(27.299 13.044)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,90.918c-1.094.551-5.268.171-5.268.171s2.175-3.582,3.269-4.12a2.218,2.218,0,1,1,2,3.961Z",
    transform: "translate(27.589 14.455)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.548,99.707c-.979.734-5.161,1.058-5.161,1.058s1.538-3.9,2.522-4.625a2.219,2.219,0,1,1,2.639,3.567Z",
    transform: "translate(27.731 15.951)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.059,99.839s6.291-21.328-1.176-37.045a33.756,33.756,0,0,1-2.725-21.145,56.665,56.665,0,0,1,2.995-9.925",
    transform: "translate(1.586 5.287)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.653,23.892c0,2.615,4.736,10.2,4.736,10.2s4.734-7.589,4.734-10.2a4.736,4.736,0,0,0-9.472,0Z",
    transform: "translate(1.441 3.193)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.042,36.662c1.423,2.2,9.521,5.988,9.521,5.988s-.147-8.941-1.57-11.134a4.736,4.736,0,0,0-7.951,5.141Z",
    transform: "translate(0.223 4.908)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.606,58.13c2.336,1.178,11.243.365,11.243.365S9.2,50.852,6.871,49.681a4.736,4.736,0,1,0-4.266,8.456Z",
    transform: "translate(0 8.196)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.338,74.075c2.1,1.555,11.02,2.257,11.02,2.257s-3.281-8.324-5.387-9.871a4.735,4.735,0,1,0-5.632,7.614Z",
    transform: "translate(0.736 10.922)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.143,42.352c-1.876,1.821-10.618,3.709-10.618,3.709s2.14-8.681,4.016-10.5a4.74,4.74,0,1,1,6.612,6.794Z",
    transform: "translate(1.587 5.703)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.483,61.252c-2.336,1.178-11.243.365-11.243.365s4.653-7.643,6.977-8.813a4.735,4.735,0,1,1,4.266,8.456Z",
    transform: "translate(2.206 8.716)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.078,80.008c-2.1,1.555-11.02,2.257-11.02,2.257s3.281-8.324,5.387-9.871a4.735,4.735,0,1,1,5.632,7.614Z",
    transform: "translate(2.509 11.911)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.671,45.364,68.024,43.6c-.553-.071-.98-.282-.965-.465s.49-.269,1.055-.189l13.618,1.971c.375.054.659.2.642.321S82.043,45.413,81.671,45.364Z",
    transform: "translate(11.176 7.152)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.762,45.417,68.073,44c-.556-.056-1.029.047-1.046.23s.426.377.98.426l13.713,1.224c.377.034.686-.039.7-.164S82.137,45.456,81.762,45.417Z",
    transform: "translate(11.171 7.331)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36,54.387l13.645-1.768c.553-.071.98-.282.965-.465s-.49-.269-1.056-.189L97.3,53.936c-.375.054-.659.2-.642.321S96.986,54.436,97.36,54.387Z",
    transform: "translate(16.109 8.656)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.277,54.44l13.689-1.415c.556-.056,1.029.047,1.045.23s-.426.377-.979.426L97.318,54.905c-.377.034-.686-.039-.7-.164S96.9,54.479,97.277,54.44Z",
    transform: "translate(16.103 8.835)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.044,66.6H55.716v47.7h3.328Z",
    transform: "translate(9.286 11.099)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.346,66.6h-3.327v47.7h3.327Z",
    transform: "translate(19.67 11.099)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,63.267H132.29a5.388,5.388,0,0,1,5.388,5.386v.715H50.009v-.715A5.387,5.387,0,0,1,55.4,63.267Z",
    transform: "translate(8.335 10.545)",
    fill: "#dfe6f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.186,63.267H132.08a5.388,5.388,0,0,1,5.388,5.386v.715H49.8v-.715a5.387,5.387,0,0,1,5.387-5.386Z",
    transform: "translate(8.3 10.545)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,62.315H132.29a5.388,5.388,0,0,1,5.388,5.386v.715H50.009V67.7A5.387,5.387,0,0,1,55.4,62.315Z",
    transform: "translate(8.335 10.386)",
    fill: "#dfe6f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.532,60.889a6.656,6.656,0,1,0-6.658-6.657A6.657,6.657,0,0,0,88.532,60.889Z",
    transform: "translate(13.646 7.929)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.335,59.311a5.276,5.276,0,1,0-5.277-5.276A5.277,5.277,0,0,0,88.335,59.311Z",
    transform: "translate(13.843 8.127)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.155,57.875a4.02,4.02,0,1,0-4.021-4.02A4.02,4.02,0,0,0,88.155,57.875Z",
    transform: "translate(14.022 8.306)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,55.864a2.26,2.26,0,1,0-2.26-2.26A2.26,2.26,0,0,0,87.9,55.864Z",
    transform: "translate(14.274 8.558)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2,63.98a6.657,6.657,0,1,0-6.658-6.657A6.657,6.657,0,0,0,85.2,63.98Z",
    transform: "translate(13.091 8.445)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.006,62.4a5.276,5.276,0,1,0-5.277-5.276A5.277,5.277,0,0,0,85.006,62.4Z",
    transform: "translate(13.288 8.642)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.827,60.966a4.02,4.02,0,1,0-4.021-4.02A4.02,4.02,0,0,0,84.827,60.966Z",
    transform: "translate(13.467 8.821)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.575,58.955a2.26,2.26,0,1,0-2.26-2.26A2.26,2.26,0,0,0,84.575,58.955Z",
    transform: "translate(13.719 9.073)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.861,63.98A6.657,6.657,0,1,0,85.2,57.323,6.657,6.657,0,0,0,91.861,63.98Z",
    transform: "translate(14.2 8.445)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.664,62.4a5.276,5.276,0,1,0-5.277-5.276A5.277,5.277,0,0,0,91.664,62.4Z",
    transform: "translate(14.398 8.642)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.484,60.966a4.02,4.02,0,1,0-4.021-4.02A4.02,4.02,0,0,0,91.484,60.966Z",
    transform: "translate(14.577 8.821)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.233,58.955a2.26,2.26,0,1,0-2.26-2.26A2.26,2.26,0,0,0,91.233,58.955Z",
    transform: "translate(14.829 9.073)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.69,54.71h27.743v1.3a9.795,9.795,0,0,1-9.8,9.793H85.486a9.793,9.793,0,0,1-9.8-9.793Z",
    transform: "translate(12.615 9.118)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,54.708A11.094,11.094,0,0,1,88.605,65.524H83.1a11.124,11.124,0,0,0,2.449.279H91.1a11.1,11.1,0,0,0,11.1-11.1Z",
    transform: "translate(13.849 9.118)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.751,101.065V97.738H57.618v3.327Z",
    transform: "translate(9.603 16.29)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.852,87.779H31.94v26.485h2.912Z",
    transform: "translate(5.323 14.63)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.564,87.779H51.652v26.485h2.912Z",
    transform: "translate(8.609 14.63)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.93,84.495c0,1.768-5.995,3.2-13.39,3.2s-13.1-1.432-13.1-3.2,5.7-3.2,13.1-3.2S59.93,82.735,59.93,84.495Z",
    transform: "translate(5.573 13.549)",
    fill: "#f6c6cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.944,84.035H60.511V86.7a2.571,2.571,0,0,1-2.571,2.571H34.352a4.407,4.407,0,0,1-4.408-4.407Z",
    transform: "translate(4.99 14.006)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.688,57.815l.631-.142a1.714,1.714,0,0,1,2.049,1.294L36,92.777l-.956.216a3.1,3.1,0,0,1-3.707-2.341L24.388,59.865a1.714,1.714,0,0,1,1.3-2.05Z",
    transform: "translate(4.057 9.605)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.142,114.665h2.912V88.182h-2.912Z",
    transform: "translate(23.524 14.697)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.431,114.665h2.912V88.182h-2.912Z",
    transform: "translate(20.238 14.697)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.438,84.9c0,1.768,5.994,3.2,13.39,3.2s13.1-1.432,13.1-3.2-5.705-3.21-13.1-3.21S119.438,83.131,119.438,84.9Z",
    transform: "translate(19.906 13.615)",
    fill: "#f6c6cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.594,89.679H122.006a2.572,2.572,0,0,1-2.571-2.571V84.44H150v.832a4.408,4.408,0,0,1-4.408,4.407Z",
    transform: "translate(19.906 14.074)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,93.4l-.956-.216,7.636-33.815a1.713,1.713,0,0,1,2.049-1.294l.631.142a1.713,1.713,0,0,1,1.3,2.049L145.9,91.054a3.1,3.1,0,0,1-3.7,2.342Z",
    transform: "translate(23.541 9.672)",
    fill: "#40414d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.594,84.691l.86-.272A145.553,145.553,0,0,1,149,65.813v-.759c.018-.548.037-1.092.064-1.623.034-.681.041-1.329.036-1.958.08-8.468-3.257-12.045-3.257-12.045s-3.918-5.587-6.266-6.674c-.2-.637-.435-1.454-.642-2.4.076-.051.149-.1.22-.157a31.819,31.819,0,0,0,2.78-2.318c1.2-1.129,2.36-2.5,2.3-4.057a2.936,2.936,0,0,0-.014-.453c-.223-1.873-2.17-3.283-2.956-5.058-.66-1.491-.462-3.151-1.041-4.664s-2.6-2.921-4.118-2.125a8.12,8.12,0,0,0-1.367,1.207,5.2,5.2,0,0,1-4.618.624c-1.587-.446-2.057-2.262-4.276-2.267a2.594,2.594,0,0,1,.561.267,3.536,3.536,0,0,0-.561-.049,2.445,2.445,0,0,1,1.694,2.059c0,.059-.009.118-.019.176-.887.477-2.052.206-3.115.188s-2.273.519-2.168,1.388a.856.856,0,0,0,0,.3c.14.659,1.021,1.156,1.129,1.765v.049a18.319,18.319,0,0,1-6.281,1.831c-.071,0-.04.086.063.21h-.063c-.4.042,2.393,2.247,2.71,2.392a39.075,39.075,0,0,0,3.794,1.324l.107.034a7.719,7.719,0,0,0-.629,3.058,8.174,8.174,0,0,0,6.382,7.834c.685.8,1.4,1.679,2.062,2.553h-.047a24.384,24.384,0,0,0-4.085,13.991,24.4,24.4,0,0,0,.167,3.143c-2.714-.154-8.545-.869-12.979-4.115-5.983-4.375-12.656-3.063-11.264-.438s8.514,4.811,9.662,5.031c.108.02.358.078.715.166-1.415.267-2.385.734-2.326,1.364.116,1.2,6.213,5.031,9.893,5.249a38.716,38.716,0,0,1,7.667,1.552c.223,5.031-.994,6.539-.994,6.539s.363.223.963.539l-.258.735a18.69,18.69,0,0,1-5.01,2.123,27.517,27.517,0,0,0-6.181,2.056l-8.285,4a4.8,4.8,0,0,0-2.743,3.768c-.181,1.7.331,3.817,3.1,5.5.171,1.378,1.014,2.987,3.225,4.461,4.285,2.85,15.548,11.387,17.08,12.551.03,2.084-.244,6.263-2.815,6.914-3.224.818-.63,3.918,1.976,3.8a3.417,3.417,0,0,0,1.937.141c2.763-.656,12.886-4.162,13.577-9.406a5.162,5.162,0,0,0,.038-.685,4.569,4.569,0,0,0-.642-2.549,4.555,4.555,0,0,1,.262.735c-.838-1.91-2.877-3.109-4.465-3.785v-.054c-.244-.1-.489-.174-.69-.245a2.06,2.06,0,0,0-.033-.424L123.083,98.18s6.9-5.687,14.037-4.811,8.269-.419,8.269-.419,3.659-3.479,4.026-7.484l.23-.061S149.629,85.154,149.594,84.691Z",
    transform: "translate(17.185 3.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,100.669s.649,7.141-2.6,8.008-.216,4.328,2.38,3.672,12.124-4.113,12.773-9.3-6.494-6.926-6.494-6.926Z",
    transform: "translate(20.484 16.02)",
    fill: "#b8616e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,100.669s.649,7.141-2.6,8.008-.216,4.328,2.38,3.672,12.124-4.113,12.773-9.3-6.494-6.926-6.494-6.926Z",
    transform: "translate(20.484 16.02)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.028,100.854s.649,7.141-2.6,8.008-.216,4.327,2.38,3.671,12.124-4.112,12.773-9.3-6.494-6.926-6.494-6.926Z",
    transform: "translate(20.67 16.051)",
    fill: "#b8616e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.071,96.494l-6.055,4.546s.027.309.043.8c2.288-.628,7.271-2.292,7.347-4.9A11.672,11.672,0,0,0,134.071,96.494Z",
    transform: "translate(21.336 16.083)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.33,43.158h-2.6v1.949h2.6Z",
    transform: "translate(21.289 7.193)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.218,70.148s-4.127,3.241-7.516,4.01a25.036,25.036,0,0,0-5.816,2.034l-7.795,3.961a4.731,4.731,0,0,0-2.581,3.729c-.223,2.2.664,5.1,5.954,6.825l16.668,13.852,5.2-4.328L117.579,86.6l13.64-8.441Z",
    transform: "translate(17.913 11.692)",
    fill: "#758ac8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.218,70.148s-4.127,3.241-7.516,4.01a25.036,25.036,0,0,0-5.816,2.034l-7.795,3.961a4.731,4.731,0,0,0-2.581,3.729c-.223,2.2.664,5.1,5.954,6.825l16.668,13.852,5.2-4.328L117.579,86.6l13.64-8.441Z",
    transform: "translate(17.913 11.692)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.274,58.712s-8.01.215-13.641-4.113-11.906-3.031-10.609-.433,8.01,4.762,9.093,4.977,16.669,4.546,16.669,4.546Z",
    transform: "translate(17.475 8.629)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.274,58.712s-8.01.215-13.641-4.113-11.906-3.031-10.609-.433,8.01,4.762,9.093,4.977,16.669,4.546,16.669,4.546Z",
    transform: "translate(17.475 8.629)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.285,68.482l-2.6,7.792s-14.611,8.982-15.8,10.172c-.925.925-2.164,4.546,2.165,7.575s16.235,12.554,16.235,12.554,9.093-1.958,8.444-5.63L122.789,90.124s6.494-5.631,13.207-4.762,7.795-.433,7.795-.433,5.2-5.2,3.463-10.17S129.285,68.482,129.285,68.482Z",
    transform: "translate(18.33 11.414)",
    fill: "#758ac8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.744,39.18s7.362,8.008,6.928,10.388,5.845-6.926,5.845-6.926A24.068,24.068,0,0,1,135,32.685Z",
    transform: "translate(20.624 5.448)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.054,45.238a21.7,21.7,0,0,1,1.584-1.51,21.921,21.921,0,0,0,3.035-3.028c1.516-1.958,7.143,6.493,7.143,6.493s3.463,3.9,3.031,13.2a214.1,214.1,0,0,0,.541,21.752l-1.31.365a7.5,7.5,0,0,1-6.636-.943c-1.729-1.195-3.918-2.448-5.584-2.561a15.092,15.092,0,0,1-6.17-2.056s1.408-3.354-.757-14.177a25.27,25.27,0,0,1,3.353-18.515S128.719,46.614,130.054,45.238Z",
    transform: "translate(20.738 6.734)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.143,81.263l-1.3.433-.772.257a7.5,7.5,0,0,1-6.636-.943c-1.727-1.192-3.918-2.448-5.584-2.561-3.242-.218-6.915-2.6-6.915-2.6s2.164-2.813,0-13.636a25.224,25.224,0,0,1,3.355-18.506s.435,2.343,1.77.965a21.337,21.337,0,0,1,1.582-1.508,21.926,21.926,0,0,0,3.035-3.028c1.516-1.959,7.142,6.492,7.142,6.492s3.463,3.9,3.032,13.2c-.047.979-.066,1.988-.069,3.009A148.483,148.483,0,0,0,146.143,81.263Z",
    transform: "translate(20.739 6.641)",
    fill: "#5e52ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.471,57.351l.216,4.762s-11.475.649-13.855-1.731,6.489,7,8.448,7.575a49.325,49.325,0,0,0,9.078,1.067,3.674,3.674,0,0,0,3.429-2.079,3.465,3.465,0,0,0,.27-2.02,57.159,57.159,0,0,1,0-8.875Z",
    transform: "translate(20.071 9.342)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.961,56.98l.216,4.762s-11.475.649-13.855-1.731-10.994-1.853-10.824,0c.108,1.19,5.846,4.977,9.305,5.195s8.008,1.8,9.967,2.38a49.325,49.325,0,0,0,9.078,1.067,3.674,3.674,0,0,0,3.429-2.078,3.465,3.465,0,0,0,.27-2.02,57.162,57.162,0,0,1,0-8.875Z",
    transform: "translate(18.582 9.28)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,44.922s-4.979.649-4.329,8.008,1.516,8.008,1.516,8.008,7.361-.649,8.225-.867.434-8.223.434-8.223S140.947,44.706,135.32,44.922Z",
    transform: "translate(21.822 7.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,44.737s-4.979.649-4.329,8.008,1.516,8.008,1.516,8.008,7.361-.649,8.225-.867.434-8.223.434-8.223S140.947,44.517,135.32,44.737Z",
    transform: "translate(21.822 7.455)",
    fill: "#5e52ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.646,37.3c-.339-1.714.358-2.243.541-4.436l-11.264,6.493s1.29,1.405,2.757,3.21a8.031,8.031,0,0,0,2.006.245C131.637,42.823,133.251,39.655,134.646,37.3Z",
    transform: "translate(20.654 5.477)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.969,43.5a8.008,8.008,0,1,0-8.01-8.008A8.009,8.009,0,0,0,128.969,43.5Z",
    transform: "translate(20.16 4.581)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8,34.006c-1.225.779-1.243,2.539-.454,3.758a9.72,9.72,0,0,0,3.456,2.784,2.092,2.092,0,0,0,1.224.4,1.808,1.808,0,0,0,.877-.443,30.329,30.329,0,0,0,2.616-2.294c1.19-1.17,2.333-2.612,2.147-4.245-.21-1.853-2.042-3.249-2.781-5-.622-1.469-.436-3.117-.98-4.617s-2.449-2.889-3.873-2.1a7.782,7.782,0,0,0-1.286,1.195,4.706,4.706,0,0,1-4.347.619c-1.493-.441-1.937-2.24-4.021-2.245a2.335,2.335,0,0,1,1.577,2.429c-.835.472-1.932.2-2.939.186s-2.2.546-2.03,1.452c.152.734,1.212,1.28,1.056,2.015A16.6,16.6,0,0,1,116.13,29.7c-.374.042,2.251,2.223,2.549,2.367a35.271,35.271,0,0,0,3.568,1.31A16.214,16.214,0,0,0,131.8,34.006Z",
    transform: "translate(19.349 3.635)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8,33.819c-1.225.779-1.243,2.539-.454,3.758a9.719,9.719,0,0,0,3.456,2.784,2.092,2.092,0,0,0,1.224.4,1.808,1.808,0,0,0,.877-.443,30.31,30.31,0,0,0,2.616-2.294c1.19-1.17,2.333-2.612,2.147-4.245-.21-1.853-2.042-3.249-2.781-5-.622-1.469-.436-3.117-.98-4.617s-2.449-2.889-3.873-2.1a7.787,7.787,0,0,0-1.286,1.195,4.706,4.706,0,0,1-4.347.619c-1.493-.441-1.937-2.24-4.021-2.245a2.335,2.335,0,0,1,1.577,2.429c-.835.473-1.932.2-2.939.186s-2.2.546-2.03,1.452c.152.734,1.212,1.28,1.056,2.015a16.6,16.6,0,0,1-5.912,1.812c-.374.042,2.251,2.223,2.549,2.367a35.243,35.243,0,0,0,3.568,1.31A16.234,16.234,0,0,0,131.8,33.819Z",
    transform: "translate(19.349 3.604)",
    fill: "#916168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,99.5a4.77,4.77,0,0,1,.35,2.548c-.649,5.2-10.174,8.657-12.773,9.3a3.443,3.443,0,0,1-3.485-1.42,3.374,3.374,0,0,0,3.7,1.854c2.6-.65,12.124-4.114,12.774-9.3A4.759,4.759,0,0,0,140,99.5Z",
    transform: "translate(20.683 16.584)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7,118.3c-.194-.436-1.2-1.286-6.039-1.469-3.316-.125-4.445-1.875-4.751-3.584a4.974,4.974,0,0,0,2.221-.61s-.015-.078-.039-.218l.039-.029a22.933,22.933,0,0,1-.331-3.731,14.351,14.351,0,0,1,.338-3.183,9.391,9.391,0,0,0,.169-2.1A76.347,76.347,0,0,0,78.87,91.9l-.2-6.079a4.223,4.223,0,0,0-2.3-3.648,3.461,3.461,0,0,0-1.555-.387s-7.675-1.209-14.583-1.868c-.49-.394-2.216-1.457-6.174-.847l-2.277-6.664a1.91,1.91,0,0,1-.039-.245c.081-.847.646-2.123,3.284-2.2l.551.49s.1-.193.262-.49c3.272-.037,21.094-.218,22.012,0,1.011.245,9.871-1.728,10.126-1.973,3.443-3.357-10.126-1.728-10.126-1.728a70.552,70.552,0,0,1-10.065-.4c2.187-3.278,4.244-14.4,4.244-14.4S79.866,47.5,77.6,45.28s-9.112,4.935-9.112,4.935-2.784,8.145-4.05,10.613c-.49.979-1.124,1.18-1.69,1.067.257-.206.424-.328.424-.328S57.6,57.125,57.095,55.4a4.126,4.126,0,0,0-.372-.81,6.921,6.921,0,0,0-1.876-4.13,4.241,4.241,0,0,0-.632-.556c-.308-.22-.659-.411-.95-.651.164-.754.355-1.537.553-2.3a8.225,8.225,0,0,0,7.347-8.079,7.973,7.973,0,0,0-.223-1.863,3.591,3.591,0,0,0,3.183-1.533,4.209,4.209,0,0,0,.108-4.25,5.261,5.261,0,0,0-1.122-1.415A6.635,6.635,0,0,0,60.54,28.21a7.241,7.241,0,0,1-2.434-1.036,10.8,10.8,0,0,1-.81-1.224,6.266,6.266,0,0,0-.98-1.141A8.958,8.958,0,0,0,51.6,22.43a25.218,25.218,0,0,0-6.543-.12c-.816.056-1.773.2-2.14.911a4.338,4.338,0,0,0-.132,1.768c-.115,1.892-2.28,2.938-4.163,3.4s-4.129.854-5.037,2.514c-.825,1.5-.245,3.315.02,5a12.221,12.221,0,0,1-1.844,8.468,35.006,35.006,0,0,0-2.549,3.751,7.15,7.15,0,0,0-.475,4.862,3.423,3.423,0,0,1,.211,1.444,2.518,2.518,0,0,1-.573,1.075,12.98,12.98,0,0,1-9.232,4.781,2.643,2.643,0,0,0,.842,1.271,6.084,6.084,0,0,0,1.748,1.207,26.413,26.413,0,0,0,5.363,2,9.346,9.346,0,0,0,3.825.326,4.008,4.008,0,0,0,3.032-2.093c.3-.666.348-1.42.617-2.1.536-1.356,1.866-2.235,2.765-3.4a84.944,84.944,0,0,0-.429,9.019v2.58a19.09,19.09,0,0,1-2.353,9.993,2.537,2.537,0,0,0-.316,1.469,1.611,1.611,0,0,0,.551,1.5,14.512,14.512,0,0,0-.213,2.566c-.029,3.094,1.016,7.249,6.56,8.3l9.871-.49s13.922-2.715,17.717-.735a1.4,1.4,0,0,1,1.109,1.366,3.147,3.147,0,0,1-.1.61,9.574,9.574,0,0,0-.12,1.941c-.017,4.162.879,13.607.879,13.607v4.006a6.292,6.292,0,0,0-1.31,3.39v.069a.208.208,0,0,0,.015.09c.015.03,0,.055.017.082a.235.235,0,0,1,.022.078.6.6,0,0,0,.032.085c.012.027.017.044.027.066s.032.063.049.093l.029.051a1.161,1.161,0,0,0,.1.134c1.266,1.469,7.591,4.311,9.619,4.2,2.153-.122,9.364.245,9.619-2.962A.39.39,0,0,0,88.7,118.3Z",
    transform: "translate(3.19 3.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.625,99.564s-2.939,3.672-1.714,5.14,7.347,4.277,9.306,4.163c2.081-.123,9.061.245,9.306-2.938,0,0,.49-1.469-5.877-1.714s-4.408-6.855-4.408-6.855Z",
    transform: "translate(10.269 16.227)",
    fill: "#594c76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.389,72.994s-2.939,10.037,5.877,11.751l9.55-.49s13.468-2.693,17.142-.734c0,0,1.469.245.98,2.2s.735,15.179.735,15.179v4.407s8.326,0,9.306-.979a20.458,20.458,0,0,1,0-7.1c.735-3.183-1.224-13.22-1.224-13.22l-.193-6.042a4.2,4.2,0,0,0-2.219-3.623,3.283,3.283,0,0,0-1.5-.382s-16.652-2.693-22.529-2.2S33.389,72.994,33.389,72.994Z",
    transform: "translate(5.486 11.95)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.389,72.784s-2.939,10.037,5.877,11.751l9.55-.49s13.468-2.693,17.142-.735c0,0,1.469.245.98,2.2s.735,15.178.735,15.178V105.1s8.326,0,9.306-.979a20.458,20.458,0,0,1,0-7.1c.735-3.183-1.224-13.22-1.224-13.22l-.193-6.042a4.2,4.2,0,0,0-2.219-3.623,3.283,3.283,0,0,0-1.5-.382s-16.652-2.693-22.529-2.2S33.389,72.784,33.389,72.784Z",
    transform: "translate(5.486 11.915)",
    fill: "#8b9cd1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.221,57.866s1.959,2.448,3.183,0,3.918-10.527,3.918-10.527,6.612-7.1,8.816-4.9-5.387,6.12-5.387,6.12S63.057,63.5,60.608,63.742a46.5,46.5,0,0,1-6.122,0l-1.224-2.693Z",
    transform: "translate(8.877 7.003)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.221,57.866s1.959,2.448,3.183,0,3.918-10.527,3.918-10.527,6.612-7.1,8.816-4.9-5.387,6.12-5.387,6.12S63.057,63.5,60.608,63.742a46.5,46.5,0,0,1-6.122,0l-1.224-2.693Z",
    transform: "translate(8.877 7.003)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.014,45.11s4.408,5.141,4.9,6.855,5.877,6.12,5.877,6.12-3.918,2.938-3.183,4.407-5.143-4.9-5.143-4.9L43.606,47.558Z",
    transform: "translate(7.268 7.518)",
    fill: "#eb6475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.014,45.11s4.408,5.141,4.9,6.855,5.877,6.12,5.877,6.12-3.918,2.938-3.183,4.407-5.143-4.9-5.143-4.9L43.606,47.558Z",
    transform: "translate(7.268 7.518)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.514,40.384s-2.2,7.1-2.2,9.793-9.306-.734-9.061-2.2,5.387-6.855,5.632-9.058S51.514,40.384,51.514,40.384Z",
    transform: "translate(6.707 6.369)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.437,44.292s-8.571-2.2-9.8,10.282.98,13.954-2.694,21.544,24.978.979,24.978.979-1.469-1.714-6.122-.979l-2.2-6.61s-.735-2.938,3.428-2.938S55.233,58,55.233,58s-2.2-7.345-3.428-8.079S48.376,44.782,45.437,44.292Z",
    transform: "translate(5.437 7.357)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.437,43.872s-8.571-2.2-9.8,10.282.98,13.954-2.694,21.544,24.978.979,24.978.979S56.457,74.964,51.8,75.7l-2.2-6.61s-.735-2.938,3.428-2.938,2.2-8.568,2.2-8.568-2.2-7.344-3.428-8.079S48.376,44.362,45.437,43.872Z",
    transform: "translate(5.437 7.287)",
    fill: "#eb6475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.128,58.959S69,60.918,71.943,60.428c0,0,13.126-1.616,9.8,1.714-.245.245-8.816,2.2-9.8,1.959s-21.795,0-21.795,0L49.9,61.652Z",
    transform: "translate(8.317 9.827)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3,55.066,52.281,66.817s2.449-4.9,3.183-4.9-8.816-14.444-8.816-14.444-2.449-2.938-3.918-1.469S36.854,46.5,39.3,55.066Z",
    transform: "translate(6.429 7.6)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.093,54.646,52.071,66.4s2.449-4.9,3.183-4.9-8.816-14.444-8.816-14.444-2.449-2.938-3.918-1.469S36.644,46.078,39.093,54.646Z",
    transform: "translate(6.394 7.53)",
    fill: "#eb6475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.169,46.159a8.079,8.079,0,1,0-8.081-8.079A8.08,8.08,0,0,0,49.169,46.159Z",
    transform: "translate(6.848 5)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.707,37.23a3.34,3.34,0,0,0,3.859-1.339,4.257,4.257,0,0,0,.1-4.216,5.971,5.971,0,0,0-3.328-2.752,6.428,6.428,0,0,1-2.427-1.087,7.146,7.146,0,0,1-.957-1.391A8.01,8.01,0,0,0,51.7,23.2a23.915,23.915,0,0,0-6.33-.12c-.788.056-1.714.2-2.072.9a4.4,4.4,0,0,0-.127,1.753c-.11,1.878-2.2,2.918-4.033,3.369s-3.95.874-4.841,2.529c-.8,1.486-.228,3.288.02,4.958a12.37,12.37,0,0,1-1.783,8.38,34.99,34.99,0,0,0-2.466,3.721,7.256,7.256,0,0,0-.46,4.823,3.486,3.486,0,0,1,.206,1.432,2.518,2.518,0,0,1-.553,1.065,12.46,12.46,0,0,1-8.931,4.754,3.934,3.934,0,0,0,2.263,2.2,25.147,25.147,0,0,0,5.187,1.978,8.836,8.836,0,0,0,3.7.323,3.9,3.9,0,0,0,2.939-2.076c.294-.661.338-1.408.6-2.083.585-1.515,2.145-2.431,2.983-3.824.8-1.332,1.112-1.488,1.315-3.026s.651-3.2,1.915-4.1a4.619,4.619,0,0,1,4.653-.039c1.469.727,2.378.443,3.6,1.51a29.876,29.876,0,0,0,7.153,4.607C56.391,54.1,56,51.72,54.263,50.45c-.49-.365-1.109-.644-1.369-1.2-.414-.889.294-1.973-.027-2.9s-1.54-1.271-2.082-2.113a2.366,2.366,0,0,1,.1-2.421,6.528,6.528,0,0,1,1.79-1.792q.9-.683,1.832-1.334a6.545,6.545,0,0,0,1.489-1.3c.245-.335.406-1.07.747-1.307C57.6,35.489,58.913,36.919,59.707,37.23Z",
    transform: "translate(3.388 3.821)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,37.02a3.34,3.34,0,0,0,3.859-1.339,4.257,4.257,0,0,0,.1-4.216,5.972,5.972,0,0,0-3.328-2.752A6.43,6.43,0,0,1,57.7,27.626a7.156,7.156,0,0,1-.957-1.39,8.01,8.01,0,0,0-5.258-3.249,23.911,23.911,0,0,0-6.33-.12c-.789.056-1.714.2-2.072.9a4.4,4.4,0,0,0-.127,1.753c-.11,1.878-2.2,2.918-4.033,3.369s-3.95.874-4.841,2.529c-.8,1.486-.228,3.288.02,4.958a12.37,12.37,0,0,1-1.783,8.38,34.953,34.953,0,0,0-2.466,3.721A7.254,7.254,0,0,0,29.4,53.3a3.49,3.49,0,0,1,.206,1.432,2.518,2.518,0,0,1-.553,1.065,12.46,12.46,0,0,1-8.931,4.754,3.934,3.934,0,0,0,2.263,2.2,25.146,25.146,0,0,0,5.187,1.978,8.836,8.836,0,0,0,3.7.323,3.9,3.9,0,0,0,2.939-2.076c.294-.661.338-1.408.6-2.083.585-1.515,2.145-2.431,2.983-3.824.8-1.332,1.112-1.488,1.315-3.026s.651-3.2,1.915-4.1a4.619,4.619,0,0,1,4.653-.039c1.469.727,2.378.443,3.6,1.51a29.878,29.878,0,0,0,7.153,4.607c-.245-2.135-.639-4.517-2.373-5.787-.49-.365-1.109-.644-1.369-1.2-.414-.889.294-1.973-.027-2.9s-1.54-1.271-2.082-2.113a2.366,2.366,0,0,1,.1-2.421,6.529,6.529,0,0,1,1.79-1.792q.9-.683,1.832-1.334a6.538,6.538,0,0,0,1.489-1.3c.245-.335.406-1.07.747-1.307C57.386,35.279,58.7,36.709,59.5,37.02Z",
    transform: "translate(3.353 3.786)",
    fill: "#916168"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.873 113.587)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.766,99.289a8.449,8.449,0,0,1,.279-1.929l-.122.042A8.515,8.515,0,0,0,68.766,99.289Z",
    transform: "translate(-60.413 -97.36)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.218,107.5c-1.959.115-8.081-2.693-9.306-4.162a1.308,1.308,0,0,1-.284-.7,1.539,1.539,0,0,0,.284,1.185c1.224,1.469,7.347,4.276,9.306,4.162,2.082-.123,9.061.245,9.306-2.938a.4.4,0,0,0-.034-.26C79.928,107.722,73.248,107.377,71.218,107.5Z",
    transform: "translate(-61.605 -96.48)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,44.166h-.245V54.2h.245Z",
    transform: "translate(13.022 7.361)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,44.166h-.245V54.2h.245Z",
    transform: "translate(13.057 7.361)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,44.166h-.245V54.2H78.8Z",
    transform: "translate(13.092 7.361)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.009,44.166h-.245V54.2h.245Z",
    transform: "translate(13.127 7.361)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.219,44.166h-.245V54.2h.245Z",
    transform: "translate(13.162 7.361)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.429,44.166h-.245V54.2h.245Z",
    transform: "translate(13.197 7.361)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.639,44.166h-.245V54.2h.245Z",
    transform: "translate(13.232 7.361)",
    fill: "#ffd77c",
    stroke: "#ffab50",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.982a4344b0fadbd39cc486cf0ca9563f.svg";
export { ForwardRef as ReactComponent };